import moment from 'moment-timezone';
import store from '@/store';
import { celciusToFarenheit } from '@/services/unitsConversion';
import Trimaster from '@/plugins/servers/trimaster';

const formatDate = function (isoDate, datemask) {
  let trimasterInstance = new Trimaster({});
  return trimasterInstance.formatDate(isoDate, datemask);
};

export const createDisplayRecord = function (device, type) {
  let preferences = store.getters.getUser.preferences.find((el) => el.preference === 'units');

  let isMetric = true;
  if (preferences && preferences.setting === 'imperial') {
    isMetric = false;
  }

  let platformGroupName = device.platformGroupName || device.controller;
  let pgSplitName = platformGroupName.split('-');
  if (pgSplitName.length === 3) {
    platformGroupName = pgSplitName[1] + '-' + pgSplitName[2];
  }
  let data = {
    facility_id: device.facility_id,
    facilityName: device.facilityName,
    dashboardDisplayType_id: device.dashboardDisplayType_id ? device.dashboardDisplayType_id : null,
    hardware_item_id: device.hardware_item_id,
    logLevel: device.logLevel,
    daysInFlower: device.daysInFlower,
    platformGroupName: platformGroupName,
    platformGroupNameFull: device.platformGroupName || device.controller,
    platformGroupType: device.platformGroupType,
    isRcu: !!device.RCUState,
    exceptionCount: device.exceptionCount,
    exceptionMessage: device.exceptionMessage,
    lightIntensityAverage: Math.round(device.lightIntensityAverage * 100),
    state: device.deployed ? device.status : 'NOT DEPLOYED',
    co2: store.getters['sensorReadings/primaryPlatformGroupSensorReading'](device.platformGroup_id, 7)?.reading, //device.co2,
    humidity: store.getters['sensorReadings/primaryPlatformGroupSensorReading'](device.platformGroup_id, 6)?.reading, //device.humidity,
    temperature: store.getters['sensorReadings/primaryPlatformGroupSensorReading'](device.platformGroup_id, 5)?.reading, //device.temperature,
    temperatureFormatted: calculateTemperatureDisplay2(
      store.getters['sensorReadings/primaryPlatformGroupSensorReading'](device.platformGroup_id, 5)?.reading,
      isMetric
    ), //calculateTemperatureDisplay2(device.temperature, isMetric),
    lastIrrigated:
      device.lastIrrigatedTime && device.lastIrrigatedTime > device.lastIrrigated
        ? device.lastIrrigatedTime
        : device.lastIrrigated,
    lastIrrigatedFormatted: timeDiffUtc(device.lastIrrigatedTime ? device.lastIrrigatedTime : device.lastIrrigated),
    nextIrrigated: device.nextIrrigatedTime,
    nextIrrigatedFormatted: timeDiffUtc(device.nextIrrigatedTime),
    targetVWC: device.targetVWC,
    cropSteeringPhase: device.cropSteeringPhase,
    area: device.areaname,
    area_id: device.area_id,
    platformGroup_id: device.platformGroup_id,
    platformGroupCollectionIds: device.platformGroupCollectionIds
      ? device.platformGroupCollectionIds.split(',').map((id) => parseInt(id))
      : [],
    id:
      device.cortexVfuDevice_id ||
      device.vfuDevice_id ||
      device.pguDevice_id ||
      device.lguDevice_id ||
      device.rcuDevice_id ||
      device.platformGroup_id,
    controller_id: device.controller_id,
    selected: false,
    co2ValveState: device.co2ValveState || '',
    lightState: device.lightState || '',
    curtainState: device.curtainState || '',
    curtainType: device.curtainType || '',
    curtainDisplayState: device.curtainDisplayState || '',
    irrigationState: device.irrigationState || '',
    vfuHumidifierState: device.vfuHumidifierState || '',
    vfuDehumidifierState: device.vfuDehumidifierState || '',
    vfu2StageDehumidifierState: device.vfu2StageDehumidifierState || '',
    ipAddress: device.ipAddress,
    softwareVersion: device.softwareVersion,
    firmwareVersion: device.firmwareVersion,
    lastCo2Update: store.getters['sensorReadings/primaryPlatformGroupSensorReading'](device.platformGroup_id, 7)
      ?.dbtime, //device.lastCo2Update,
    co2SensorName: store.getters['sensorReadings/primaryPlatformGroupSensorReading'](device.platformGroup_id, 7)?.name,
    lastCommandFetch: device.lastCommandFetch,
    lastHumidityUpdate: store.getters['sensorReadings/primaryPlatformGroupSensorReading'](device.platformGroup_id, 6)
      ?.dbtime, //device.lastHumidityUpdate,
    humiditySensorName: store.getters['sensorReadings/primaryPlatformGroupSensorReading'](device.platformGroup_id, 6)
      ?.name,
    lastTempUpdate: store.getters['sensorReadings/primaryPlatformGroupSensorReading'](device.platformGroup_id, 5)
      ?.dbtime, //device.lastTempUpdate,
    tempSensorName: store.getters['sensorReadings/primaryPlatformGroupSensorReading'](device.platformGroup_id, 5)?.name,
    uptime: device.registered,
    uptimeFormatted: timeDiff(device.registered),
    loginTime: device.registered,
    ECUState: device.ECUState || '',
    BardState: device.BardState || '',
    heaterstripState: device.heaterstripState ? (device.heaterstripState === 'HIGH' ? 'ON' : 'OFF') : '',
    warnMessage: device.warnMessage || '',
    mode: device.mode,
    type: type,
    lifecyclesRaw: device.lifecycles,
    formattedLoginTime: formatDate(device.loginTime),
    formattedLastCommandFetch: timeDiff(device.lastCommandFetch),
    currentState: '',
    ticketCount: device.ticketCount,
    deployed: device.deployed,
    disabled: device.isDisabled,
    tempLow: false,
    tempHigh: false,
    humidityLow: false,
    humidityHigh: false,
    co2Low: false,
    co2High: false,
    status: '',
    hasLifecycles: !!device.lifecycles,
    isTesting: device.isTesting,
    pestDetected: !!device.pestDetected,
    co2Enabled: !!(device.co2Enabled && (device.co2Enabled === 1 || device.co2Enabled.toUpperCase() === 'TRUE')),
    facilityCo2Enabled: !!(
      device.facilityCo2Enabled &&
      (device.facilityCo2Enabled === 1 || device.facilityCo2Enabled.toUpperCase() === 'TRUE')
    ),
    dewpoint: calcDewpoint(
      store.getters['sensorReadings/primaryPlatformGroupSensorReading'](device.platformGroup_id, 5)?.reading,
      store.getters['sensorReadings/primaryPlatformGroupSensorReading'](device.platformGroup_id, 6)?.reading
    ),
    strainName: device.lifecycles && device.lifecycles.length > 0 ? device.lifecycles[0].strainName : '<none>',

    xFertility: store.getters['sensorReadings/primaryPlatformGroupSensorReading'](device.platformGroup_id, 62)?.reading, //device.xFertility,
    xLux: store.getters['sensorReadings/primaryPlatformGroupSensorReading'](device.platformGroup_id, 58)?.reading, //device.xLux,
    xMoisture: store.getters['sensorReadings/primaryPlatformGroupSensorReading'](device.platformGroup_id, 53)?.reading, //device.xMoisture,
    xTemp: !isNaN(
      parseFloat(
        store.getters['sensorReadings/primaryPlatformGroupSensorReading'](device.platformGroup_id, 57)?.reading
      )
    )
      ? calculateTemperatureDisplay2(
          store.getters['sensorReadings/primaryPlatformGroupSensorReading'](device.platformGroup_id, 57)?.reading,
          isMetric
        )
      : '',
    xFertilitySensorName: store.getters['sensorReadings/primaryPlatformGroupSensorReading'](device.platformGroup_id, 62)
      ?.name,
    xLuxSensorName: store.getters['sensorReadings/primaryPlatformGroupSensorReading'](device.platformGroup_id, 58)
      ?.name,
    xMoistureSensorName: store.getters['sensorReadings/primaryPlatformGroupSensorReading'](device.platformGroup_id, 53)
      ?.name,
    xTempSensorName: store.getters['sensorReadings/primaryPlatformGroupSensorReading'](device.platformGroup_id, 57)
      ?.name,
    isDnD: device.isDnD,
    dndExpiration: device.dndExpiration,
    dndUserName: device.dndUserFirstName + ' ' + device.dndUserLastName,
    dndComment: device.dndComment,

    infoIconColor: 'primary',
    title: '',
    macAddress: device.macAddress,
    isDisconnected: typeof device.isDisconnected === 'undefined' ? false : device.isDisconnected,
    useVfuSchedule: device.useVfuSchedule,
  };

  if (device.lifecycles) {
    for (let i = 0; i < device.lifecycles.length; i++) {
      if (typeof device.lifecycles[i].currentPhase == 'object') {
        let minutes = moment.utc().diff(moment.utc(device.lifecycles[i].currentPhase.starttime), 'minutes');
        device.lifecycles[i].daysInPhase = Math.ceil(minutes / 60 / 24);
        let sPhase = device.lifecycles[i].currentPhase.scheduledEnd;
        let totalMinutes = moment
          .utc(sPhase)
          .diff(moment.utc(device.lifecycles[i].currentPhase.scheduledStart), 'minutes');
        device.lifecycles[i].totalDaysInPhase = Math.ceil(totalMinutes / 60 / 24);
      } else {
        console.error('currentPhase not found for ', device);
      }
    }
  }

  if (device.isDisabled) {
    device.state = 'DISABLED';
  }

  if (device.platformGroupType === 'VFU') {
    data.currentState = device.CortexVfuState || device.VFUState;
  }

  if (device.RCUState) {
    data.currentState = device.RCUState;
  }
  data.sortableCurrentState = data.isDisconnected ? 'DISCONNECTED' : data.currentState;

  if (device.lightState === 'on') {
    data.lightStateTooltip = 'Lights On';
  } else {
    data.lightStateTooltip = 'Lights Off';
  }

  if (device.modalInfo) {
    data.lastUpdated = new Date(device.modalInfo['Last Update']);
  } else {
    data.lastUpdated = null;
  }

  // lifecycle-related tooltips
  if (device.lifecycles && device.lifecycles.length > 0) {
    data.lifecycles = true;
    data.lifecyclesTooltip = device.lifecycles[0].growplanName + ' (' + device.lifecycles[0].lifecycle_id + ')';
    ' - ' + device.lifecycles[0].strainName;

    if (device.lifecycles[0].currentPhase && typeof device.lifecycles[0].currentPhase.photoperiod == 'number') {
      data.lightStateTooltip =
        'Photoperiod : ' +
        device.lifecycles[0].currentPhase.photoperiod +
        ' hours, starting at ' +
        device.lifecycles[0].currentPhase.photoperiodStartTime +
        ' local time';
    }
  } else {
    data.lifecycles = false;
  }

  if (device.temperature && device.humidity) {
    data.vpd = calcVpd(device.temperature, device.humidity);
  } else {
    data.vpd = null;
  }

  // is offline?
  let dur = moment.duration(moment().diff(moment(device.lastCommandFetch))).asMinutes();

  if (dur && dur >= 17 && !device.isTesting) {
    data.state = 'OFFLINE';
    data.uptime = '-';
    data.uptimeFormatted = '-';
  }

  data.lastTempReadingTime = moment().diff(moment(data.lastTempUpdate), 'minutes');
  if (data.lastTempReadingTime > 20 && data.state === 'HEALTHY') {
    data.state = 'WARN';
    data.warnMessage = 'Temperature reading is ' + data.lastTempReadingTime + ' minutes old';
  }

  data = onVfuDataChange(data);

  if (!data.deployed) {
    data.status = 'UNDEPLOYED';
    data.state = 'UNDEPLOYED';
    data.warnMessage = '';
  }

  return data;
};

export const calculateDewpoint = function (temperature, isCelsius, humi, isReturnTypeCelsius) {
  let temp = null;

  if (isCelsius) {
    temp = temperature;
  } else {
    temp = (temperature - 32) / 1.8;
  }

  let ans =
    temp -
    (14.55 + 0.114 * temp) * (1 - 0.01 * humi) -
    Math.pow((2.5 + 0.007 * temp) * (1 - 0.01 * humi), 3) -
    (15.9 + 0.117 * temp) * Math.pow(1 - 0.01 * humi, 14);

  if (isReturnTypeCelsius) {
    return ans; // returns dew Point in Celsius
  } else {
    let value = ans * (9.0 / 5.0);
    return value + 32.0;
  }
};

export const calculateTemperatureDisplay = function (tempInCelcius) {
  let preferences = store.getters.getUser.preferences.find((el) => el.preference === 'units');
  if (preferences && preferences.setting === 'imperial') {
    return `${parseFloat(celciusToFarenheit(tempInCelcius)).toFixed(1)} F`;
  }
  return `${parseFloat(tempInCelcius).toFixed(1)} C`;
};

export const calculateTemperatureDisplay2 = function (tempInCelcius, isMetric) {
  if (isMetric) {
    return `${parseFloat(tempInCelcius).toFixed(1)} C`;
  } else {
    return `${parseFloat(celciusToFarenheit(tempInCelcius)).toFixed(1)} F`;
  }
};

export const calcDewpoint = function (temp, hum) {
  if (!temp || !hum) {
    return '--';
  }
  let dp = temp - (100 - hum * 100) / 5;
  dp = calculateTemperatureDisplay(dp);

  return dp;
};

export const calcVpd = function (tempC, humidity, vpdAdjustment) {
  if (!vpdAdjustment) {
    vpdAdjustment = 0;
  }

  if (!tempC || !humidity) {
    return '--';
  }
  tempC = Number(tempC);
  humidity = Number(humidity);

  let preferences = store.getters.getUser.preferences.find((el) => el.preference === 'units');
  if (preferences && preferences.setting === 'imperial') {
    // vpdAdjustment expressed in F -- convert to C : 1C = 1.8F
    vpdAdjustment = vpdAdjustment / 1.8;
  }

  // humidity expressed in decimals, e.g. .5 is 50% RH
  let aSvp = (610.78 * Math.exp((tempC / (tempC + 238.3)) * 17.2694)) / 1000; // in kPa
  if (vpdAdjustment === 0) {
    return Math.round(aSvp * (1 - humidity) * 100) / 100;
  } else {
    tempC += vpdAdjustment;
    let lSvp = (610.78 * Math.exp((tempC / (tempC + 238.3)) * 17.2694)) / 1000; // in kPa

    return (lSvp - aSvp * humidity).toFixed(2);
  }
};

export const lateTimeDiff = function (item) {
  return Math.floor(item.lateIrrigationInMinutes) + ' mins late';
};

export const onVfuDataChange = function (data) {
  const env = process.env;

  let isDemo = false;
  if (env.VUE_APP_env === 'dev') {
    isDemo = true;
  }

  if (data.lifecycles) {
    let lightsOn = {};
    let lightsOff = {};
    for (let i = 0; i < data.lifecyclesRaw.length; i++) {
      if (data.lifecyclesRaw[i].currentPhase) {
        let envs = data.lifecyclesRaw[i].currentPhase.environments;
        for (let j = 0; j < envs.length; j++) {
          if (envs[j].lightState === 'Lights On') {
            lightsOn = envs[j];
          } else {
            lightsOff = envs[j];
          }
        }
      }
    }

    if (typeof data.lifecyclesRaw[0].currentPhase == 'object') {
      let photoPeriod = data.lifecyclesRaw[0].currentPhase.photoperiod;

      if (photoPeriod === 24) {
        data = validateEnvironment(data, lightsOn);
      } else {
        if (data.currentState === 'LIGHT') {
          data = validateEnvironment(data, lightsOn);
        } else if (data.currentState === 'DARK') {
          data = validateEnvironment(data, lightsOff);
        } else {
          let startTime = moment().format('DD') + ' ' + data.lifecyclesRaw[0].currentPhase.photoperiodStartTime;

          let sTime = moment.utc(startTime, 'DD HH:mm');

          let eTime = sTime.clone().add(photoPeriod, 'hours');

          if (moment.utc().isBetween(sTime, eTime)) {
            data = validateEnvironment(data, lightsOn);
          } else {
            data = validateEnvironment(data, lightsOff);
          }
        }
      }
    }
  }

  // set icon
  data.title = 'Click to inspect';
  if (data.logLevel === 'DEBUG') {
    data.infoIcon = 'bug_report';
  } else if (data.isDnD && moment.utc(data.dndExpiration).isAfter(moment.utc())) {
    data.title =
      'DO NOT DISTURB UNTIL ' +
      moment.utc(data.dndExpiration).local().format('YYYY-MM-DD H:mm a') +
      '\n' +
      data.dndComment +
      ' Contact ' +
      data.dndUserName +
      '.';
    data.infoIcon = 'do_not_disturb_on_total_silence';
  } else {
    data.infoIcon = 'info';
  }

  // set icon color

  if (data.state === 'OFFLINE' && !data.disabled && !data.isTesting && !isDemo) {
    data.infoIconColor = 'error';
  } else if ((data.disabled && !data.isTesting) || (data.state === 'UNDEPLOYED' && !data.isTesting)) {
    data.infoIconColor = 'black';
  } else if ((data.state === 'WARN' || data.lastTempReadingTime > 20) && !data.isTesting) {
    data.infoIconColor = 'warning';
  }

  data.scheduleTitle = 'No schedule running';
  data.scheduleIcon = 'alarm_off';
  data.scheduleIconColor = 'black';
  if (data.useVfuSchedule) {
    data.scheduleTitle = 'VFU schedule running';
    data.scheduleIcon = 'alarm';
    data.scheduleIconColor = 'primary';
  } else {
    data.scheduleTitle = 'Grow plan schedule running';
    data.scheduleIcon = 'filter_vintage';
    data.scheduleIconColor = 'green';
  }

  return data;
};

export const validateEnvironment = function (device, environment) {
  let deviceStatus = [];
  if (device.temperature && environment && environment.temp) {
    device.tempLow = false;
    device.tempHigh = false;
    if (Math.round(device.temperature * 100) / 100 < environment.temp.min) {
      device.tempLow = true;
      deviceStatus.push('Temperature Low');
    } else if (device.temperature > environment.temp.max + 0.5) {
      deviceStatus.push('Temperature High');
      device.tempHigh = true;
    }
  }
  if (device.humidity && environment && environment.humidity) {
    device.humidityHigh = false;
    device.humidityLow = false;
    if (device.humidity * 100 < environment.humidity.min) {
      deviceStatus.push('Humidity Low');
      device.humidityLow = true;
    } else if (device.humidity * 100 > environment.humidity.max + 0.5) {
      deviceStatus.push('Humidity High');
      device.humidityHigh = true;
    }
  }

  if (device.co2Enabled && device.co2 && environment && environment.co2) {
    device.co2Low = false;
    device.co2High = false;
    if (device.co2 < environment.co2.min) {
      deviceStatus.push('CO2 Low');
      device.co2Low = true;
      device.co2High = false;
    } else if (device.co2 > environment.co2.max) {
      // ignore high co2 if lights off, unless CO2 is super-high in dark
      if (environment.lightState !== 'Lights Off' || (environment.lightState === 'Lights Off' && device.co2 > 2000)) {
        deviceStatus.push('CO2 High');
        device.co2High = true;
        device.co2Low = false;
      }
    }
  }

  if (device.state !== 'OFFLINE') {
    if (deviceStatus.length > 0) {
      device.warnMessage = deviceStatus.join(',');
      device.state = 'WARN';
    } else {
      device.state = 'HEALTHY';
      device.warnMessage = '';
    }
  }

  // check last irrigated
  device.lateIrrigation = false;
  if (device.lastIrrigated) {
    if (environment.irrigation) {
      let freq = environment.irrigation.frequency;
      let irrigationRequired =
        environment.irrigation.duration !== 0 &&
        device.lifecyclesRaw &&
        device.lifecyclesRaw.length > 0 &&
        !device.lifecyclesRaw[0].currentPhase.noIrrigation;
      let currentTime = moment().utc();
      let irrigationStartTime = moment.utc(environment.irrigation.startTime, 'HHmm');
      let irrigationEndTime = moment.utc(environment.irrigation.finishTime, 'HHmm');
      if (
        environment.irrigation.startTime === environment.irrigation.finishTime &&
        currentTime.isBefore(irrigationStartTime)
      ) {
        irrigationStartTime.subtract(1, 'days');
      }
      if (
        irrigationEndTime.isBefore(irrigationStartTime) ||
        (environment.irrigation.startTime === environment.irrigation.finishTime &&
          currentTime.isAfter(irrigationStartTime))
      ) {
        irrigationEndTime.add(1, 'days');
      }
      let lastValidIrrigation = moment.utc(device.lastIrrigated);
      if (lastValidIrrigation.isBefore(irrigationStartTime)) {
        lastValidIrrigation = irrigationStartTime;
      }
      let duration = moment.duration(currentTime.diff(moment.utc(lastValidIrrigation)));
      if (
        duration.asMinutes() > freq + 10 &&
        irrigationRequired &&
        currentTime.isAfter(irrigationStartTime) &&
        currentTime.isBefore(irrigationEndTime)
      ) {
        device.lateIrrigation = true;
        device.lateIrrigationInMinutes = duration.asMinutes() - freq;
        if (device.state !== 'OFFLINE') device.state = 'WARN';
      }
    } else {
      device.lateIrrigation = true;
      if (device.state !== 'OFFLINE') device.state = 'WARN';
    }
  }

  return device;
};

export const timeDiff = function (t) {
  if (t && moment(t).isValid()) {
    return moment(t).fromNow();
  } else {
    return '-';
  }
};

export const timeDiffUtc = function (t) {
  if (t && moment(t).isValid()) {
    return moment.utc(t).fromNow();
  } else {
    return '-';
  }
};

export const minuteDiffUtc = function (t) {
  if (t && moment(t).isValid()) {
    let m_t = moment.utc(t);
    return moment().diff(m_t, 'minutes');
  } else {
    return 0;
  }
};

export const roundTo = function (value, decimals) {
  if (!decimals || decimals === '0') {
    return Math.round(value);
  }

  return Number(Math.round(value + 'e' + decimals) + 'e-' + decimals);
};
